const NotifyPositionEnum = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
} as const;

type NotifyPositionEnum = (typeof NotifyPositionEnum)[keyof typeof NotifyPositionEnum];

const NotifyTypeEnum = {
  INFO: "info",
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  DEFAULT: "default"
} as const;

type NotifyTypeEnum = (typeof NotifyTypeEnum)[keyof typeof NotifyTypeEnum];

const NotifyThemeEnum = {
  LIGHT: "light",
  DARK: "dark",
  COLORED: "colored"
} as const;

type NotifyThemeEnum = (typeof NotifyThemeEnum)[keyof typeof NotifyThemeEnum];

export { NotifyPositionEnum, NotifyTypeEnum, NotifyThemeEnum };
